export interface AccessVersion {
    access_version_change_status: boolean;
    access_version_edit_labels: boolean;
    access_version_original_name: boolean;
    access_version_read_comments: boolean;
    // access_version_share_request_archive: boolean;
    // access_version_share_request_reset: boolean;
    access_version_upload_no_file: boolean;
    access_version_write_comments: boolean;
    access_version_archive_request_feedback: boolean;
}

export const AccessVersionKeys = {
    CHANGE_STATUS: "access_version_change_status",
    EDIT_LABELS: "access_version_edit_labels",
    ORIGINAL_NAME: "access_version_original_name",
    READ_COMMENTS: "access_version_read_comments",
    // ARCHIVE_SHARE: "access_version_share_request_archive",
    // RESET_SHARE: "access_version_share_request_reset",
    UPLOAD_NO_FILE: "access_version_upload_no_file",
    WRITE_COMMENTS: "access_version_write_comments",
    ARCHIVE_REQUEST_FEEDBACK: "access_version_archive_request_feedback",
}